export enum TempFileStatusEnum {
    Received = 1,
    Ok = 2,
    Error = 3
}